import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import { apiCall } from "../base";

export const JobOrderWorkflowWorkchestra = (jobOrderNumber: string) => {
  return {
    name: `JobOrderWorkflowWorkchestra_${jobOrderNumber}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER_WORKFLOW}/${ENDPOINT.TEMPLATE_BY_WORKCHESTRA}`,
        method: HttpMethod.GET,
        params: { jobOrderNumber }
      })
  };
};

export const JobOrderWorkflowMaster = (
  jobOrderNumber: string,
  search: string | null = null
) => {
  return {
    name: `JobOrderWorkflowMaster_${jobOrderNumber}_${JSON.stringify(search)}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER_WORKFLOW}/${ENDPOINT.TEMPLATE_BY_MASTER}`,
        method: HttpMethod.GET,
        params: { search, jobOrderNumber }
      })
  };
};

export const JobOrderWorkflow = (jobOrderId: number) => {
  return {
    name: `JobOrderWorkflow_${jobOrderId}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER_WORKFLOW}/${jobOrderId}`,
        method: HttpMethod.GET
      })
  };
};

export const AddJobOrderWorkflow = () => {
  return {
    name: `AddJobOrderWorkflow`,
    handle: (body: any): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER_WORKFLOW}`,
        method: HttpMethod.POST,
        body
      })
  };
};

export const UpdateJobOrderWorkflowDate = () => {
  return {
    name: `UpdateJobOrderWorkflowDate`,
    handle: ({ id, body }: { id: number; body: any }): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER_WORKFLOW}/update-date/${id}`,
        method: HttpMethod.PUT,
        body
      })
  };
};

export const UpdateJobOrderWorkflowDateBatch = () => {
  return {
    name: `UpdateJobOrderWorkflowDateBatch`,
    handle: (body: any): Promise<any> =>
      apiCall<any>({
        url: `${ENDPOINT.JOB_ORDER_WORKFLOW}/update-date-batch`,
        method: HttpMethod.PUT,
        body
      })
  };
};
